import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { AzureCosmosDbDataset } from 'app/model/dataset/azure-cosmos-db.dataset';
import { Metamodel } from 'app/model/base/model';
import { writeBehaviorAllOptions, writeBehaviorOptionValues } from 'app/shared/constants/write-behavior.const';
import { Constants } from 'app/shared/shared-constants';
import { format } from 'app/shared/utils/string.util';
import { maxConcurrentConnectionsMetadata, disableMetricsCollectionCheckboxMetadata } from '../consts/metadata-consts';
import { defaultSupportedColumnTypes, ColumnType } from 'app/shared/utils/column-type.util';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';

const comosSinkWriteBehaviors = [writeBehaviorOptionValues.insert, writeBehaviorOptionValues.upsert];
export const documentDbCollectionMetadata: IDatasetTypeMetadata = {
    type: Metamodel.modelFor(AzureCosmosDbDataset).name,
    displayName: stringResources.DocumentDbCollection_DisplayText,
    supportLinkedServiceTypes: [adfModelTypeMap.cosmosSql.linkedServiceType],
    isSource: true,
    isSink: true,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-AzureCosmosDB'
    },
    tableNameDisplay: stringResources.TableNameDisplay_CollectionName,
    tableNamePlural: stringResources.Collections,
    isFirstClass: true,
    isTableNameRequired: true,
    category: ['Azure'],
    supportDataTypes: defaultSupportedColumnTypes.concat(ColumnType.Object),
    copySourceControls: [
        {
            type: 'parameterizable',
            child: {
                type: 'textbox',
                bind: 'nestingSeparator',
                isLabelVertical: false,
                label: stringResources.NestingSeparatorFieldLabel,
                description: stringResources.AzureCosmos_NestingSeparatorDescription_ForSource
            },
            dynamicContentTextClass: 'input-spaced'
        }
    ],
    copySinkControls: [
        {
            type: 'parameterizable-dropdown',
            bind: 'writeBehavior',
            label: stringResources.ModelName_WriteBehavior,
            isLabelVertical: false,
            options: writeBehaviorAllOptions
                .filter((option) => comosSinkWriteBehaviors.indexOf(option.value) >= 0)
        },
        {
            type: 'parameterizable',
            child: {
                type: 'textbox',
                bind: 'nestingSeparator',
                isLabelVertical: false,
                label: stringResources.NestingSeparatorFieldLabel,
                description: stringResources.AzureCosmos_NestingSeparatorDescription_ForSink
            },
            dynamicContentTextClass: 'input-spaced'
        },
        {
            type: 'parameterizable',
            child: {
                type: 'textbox',
                bind: 'writeBatchTimeout',
                label: stringResources.ModelName_WriteBatchTimeout,
                validators: [
                    {
                        type: 'pattern',
                        pattern: Constants.timeoutValidationPattern,
                        errorMessage: format(stringResources.InvalidTimeoutPattern, stringResources.ModelName_WriteBatchTimeout)
                    }
                ]
            },
            dynamicContentTextClass: 'input-spaced'
        },
        {
            type: 'parameterizable',
            child: {
                type: 'textbox-number',
                bind: 'writeBatchSize',
                label: stringResources.ModelName_WriteBatchSize,
                inputType: 'number',
                min: 0
            },
            dynamicContentTextClass: 'input-spaced'
        },
        maxConcurrentConnectionsMetadata,
        disableMetricsCollectionCheckboxMetadata
    ]
};
